<template>
    <Modal ref="modal"
           title="בחרו תבנית להודעה"
           :hideFooter="true">

        <template v-slot:body>

            <div>

                בחרו את התבנית להודעה שאתם רוצים.

                לאחר מכן ניתן יהיה לערוך שינויים.
                <br>


                <!-- allow-empty off: clicking the template that is already chosen used to UN-choose it (null),
                     the preview below failed on null.text, the popup froze on the old picture and בחר threw -
                     a dead button (2/11/2026) -->
                <Multiselect :options="$store.state.messageTemplates"
                             deselect-label=""
                             placeholder=""
                             v-model="chosenMessageTemplate"
                             selectLabel=""
                             track-by="id"
                             label="title"
                             class="mb-3"
                             selectedLabel=""
                             :allow-empty="false"
                             :taggable="false"
                             @input="chooseError = false">


                    <template slot="noResult">לא נמצאו תוצאות</template>
                    <template slot="noOptions">אין אפשרויות</template>
                </Multiselect>

                <span class="formErrorText"
                      v-if="chooseError">
                    בחרו תבנית מהרשימה
                </span>

                <br>
                תצוגה מקדימה:
                <br>


                <textarea disabled
                          class="form-control"
                          style="height: 200px;"
                          :value="previewText"></textarea>

                <br>
                <br>


                <button type="button"
                        class="btn btn-primary pull-right"
                        @click="choose">

                    בחר

                </button>


            </div>

        </template>

    </Modal>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'MessageTemplatePopup',
    methods: {
        show() {
            this.chooseError = false;
            this.$refs.modal.show();
        },

        //the template as the store holds it now (it may have been edited since it was chosen)
        currentTemplate() {

            let chosen = this.chosenMessageTemplate;

            if (!chosen || !chosen.id)
                return null;

            let templates = this.$store.state.messageTemplates || [];

            return templates.find(template => template.id == chosen.id) || chosen;
        },

        choose() {

            let template = this.currentTemplate();

            //nothing chosen: say so, never send an empty text over what is already written
            if (!template) {
                this.chooseError = true;
                return;
            }

            this.$emit('text', template.text || '');

            this.$refs.modal.hide();
        },
    },
    computed: {
        previewText() {

            let template = this.currentTemplate();

            return template ? (template.text || '') : '';
        },
    },
    data() {
        return {
            chosenMessageTemplate: null,
            chooseError: false,
        }
    },
    components: { Multiselect }
}

</script>
